import { GrowthBook } from '@growthbook/growthbook';
import mixpanel from 'mixpanel-browser';

function initializeGrowthBook() {
  const apiHost = process.env.REACT_APP_GROWTHBOOK_API_HOST;
  const clientKey = process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY;
  const enableDevMode = process.env.REACT_APP_GROWTHBOOK_DEV_MODE?.toLowerCase() === 'true';

  if (apiHost === undefined || clientKey === undefined) {
    throw new Error('GrowthBook API host or client key is not defined');
  }

  const gbInstance = new GrowthBook({
    apiHost,
    clientKey,
    enableDevMode,
    trackingCallback: (experiment, result) => {
      if (mixpanel.track !== undefined) {
        mixpanel.track('Experiment Viewed', {
          experimentId: experiment.key,
          variationId: result.key,
        });
      }
    },
  });

  gbInstance.init({
    streaming: true,
    skipCache: true,
  });

  return gbInstance;
}
export { initializeGrowthBook };
